<script>
  import { Router, Link, Route } from 'svelte-navigator';
  import SketchfabModel from './SketchfabModel.svelte';
  import { useNavigate, useFocus } from 'svelte-navigator';
  const navigate = useNavigate();
  const registerFocus = useFocus();
  let hoverTitle = false;
  function toggleTitle() {
    hoverTitle = !hoverTitle;
  }
</script>

<img src="/statics/trappe.jpg" alt="trappe" class="asphone" />

<section class=" relative">
  <div class="  mx-auto items-center flex flex-wrap-reverse">
    <div
      class="w-full md:w-full lg:w-5/12 xl:w-5/12 px-4 as-home-img asdesk"
      style=""
    ></div>
    <div class="w-full md:w-full lg:w-6/12 xl:w-6/12 px-0 text-left">
      <div class="container">
        <span>
          <div class="as-titre-1" class:hoverTitle>Configurez</div>
          <div class="as-titre-2">votre trappe sur mesure</div>

          <div class="as-content">
            <!-- <div class="as-soustitre">
              Configurez dès maintenant la trappe de vos besoins !
            </div> -->
            <p>
              La gamme de trappes sur-mesure Semin est constituée de trappes de
              visites coupe-feu, métalliques, en plaque de plâtre hydro, à
              carreler ou encore pour vide sanitaire.
            </p>
            <p class="mb-8 as-last-p">
              Ces produits sont des indispensables de vos travaux pour faciliter
              l’inspection et les réparations de gaines, VMC et plomberie. Selon
              les besoins, les trappes disposent de certifications concernant la
              résistance au feu, l’isolation acoustique, l’étanchéité à l’air et
              à la poussière.
            </p>
            <div class="center-phone">
              <div
                class="as-btn-rounded as-btn-text"
                on:click="{() => navigate('/LayoutPage')}"
                style=""
                use:registerFocus
              >
                Démarrer votre configuration
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="w-full md:w-full lg:w-1/12 xl:w-1/12 px-0"></div>
  </div>
</section>

<style>
  .hoverTitle {
    color: #909090;
    -webkit-text-stroke: 2px transparent;
  }
  .as-content {
    max-width: 650px;
    margin-top: 40px;
  }
  .as-content p {
    margin-top: 20px;
  }
  .as-titre-1,
  .as-titre-2 {
    font-family: 'introblack';
    font-size: 102px;
    line-height: 50px;
    transition: color 300ms;
  }
  .as-titre-1 {
    color: #fff;
    -webkit-text-stroke: 2px #000;
    padding-top: 30px;
  }
  .as-titre-2 {
    font-size: 75px;
    padding-bottom: 30px;
  }
  /* .as-soustitre {
    font-family: 'introblack';
    font-size: 35px;
    line-height: 40px;
  } */
  .as-home-img {
    height: 650px;
    background: url('/statics/trappe.jpg') top left no-repeat;
    background-size: cover;
  }
  .container {
    padding-left: 30px;
  }
  .as-btn-text {
    font-size: 32px;
  }
  @media only screen and (max-width: 768px) {
    .container {
      padding: 10px;
    }
    .as-content {
      margin-top: 0;
    }
    .as-titre-1,
    .as-titre-2 {
      line-height: 8vw;
    }
    .as-titre-1 {
      font-size: 15vw;
    }
    .as-titre-2 {
      font-size: 7vw;
      padding-bottom: 0;
    }
    .as-last-p {
      margin-bottom: 0;
    }
    .as-btn-text {
      font-size: 6vw;
    }
    .as-btn-rounded {
      font-size: 4vw;
      margin: 40px auto 20px;
    }
    .center-phone {
      text-align: center;
    }
  }
</style>
